import React from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
import { clientLogger } from '../../../lib/logger';
import { useScreenSizeInfo } from '../ScreenSizeInfoProvider';
import { get } from 'lodash';

const AppsBanner = props => {
  const {
    content: {
      header = '',
      body = '',
      imageUrl = '',
      title = '',
      style = ''
    } = {}
  } = props;

  // Style object schema to update the Banner from ps
  let paragraphTag = {},
    headerTag = {},
    descriptionContainer = {};

  if (style) {
    try {
      const { isMobile } = useScreenSizeInfo();
      const styleObject = JSON.parse(style);
      descriptionContainer = get(
        isMobile ? styleObject.mobileView : styleObject.webView,
        'descriptionContainer',
        {}
      );
      headerTag = get(
        isMobile ? styleObject.mobileView : styleObject.webView,
        'headerTag',
        {}
      );
      paragraphTag = get(styleObject, 'webView.paragraphTag', {});
    } catch (error) {
      clientLogger.warn(
        `Corrupt JSON in the style object ${style}, Error : ${error}`
      );
    }
  }

  return (
    <section id="appcenter-banner">
      <div className="banner-wrapper">
        <div className="description-container" style={descriptionContainer}>
          <h2 className="vx_text-3 headerTag" style={headerTag}>
            {header}
          </h2>
          <p className="paragraphTag" style={paragraphTag}>
            {body}
          </p>
        </div>
        <OptimizedImage
          imageUrl={imageUrl}
          className={`banner-image`}
          title={title}
          disableOptimization={true}
        />
      </div>
    </section>
  );
};

AppsBanner.propTypes = {
  content: PropTypes.object
};

export default AppsBanner;
